var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"list-table mt-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-right"},[_c('div',{},[_c('button',{staticClass:"btn-download mr-5",on:{"click":_vm.downloadTable}},[_vm._v(_vm._s(_vm.$t("events.listEvents.donwloadBtn")))])])]),_c('div',{staticClass:"col-md-12"},[_c('v-server-table',{ref:"travelFinishedTable",staticClass:"mt-5",attrs:{"columns":_vm.table_options.columns,"options":_vm.table_options.options,"id":"travelFinishedTable"},scopedSlots:_vm._u([{key:"actions",fn:function(props){return [_c('router-link',{staticClass:"edit-btn",attrs:{"to":{
              name: 'Trip Details',
              params: {
                id: props.row.id,
                travelStatus: props.row.travelStatus,
                data: props.row,
                details: true,
                tripDone: true,
                onGoingOrDone: true,
              }
            }}},[_c('i',{staticClass:"far fa-eye"})])]}}])})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }